import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { CustomField, useCustomField } from './useData';
import { moduleConfig, getDetailSections, getToolbarIcon } from './config';
import { useParams } from 'react-router-dom';

const Detail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const fieldId = id ? parseInt(id, 10) : null;

  const useCustomFieldData = () => {
    const { data, isLoading, mutate } = useCustomField(fieldId);
    return {
      data,
      isLoading,
      mutate,
    };
  };

  return (
    <GenericDetailPage<CustomField>
      useData={useCustomFieldData}
      config={{
        ...moduleConfig,
        getDetailSections,
      }}
    />
  );
};

export default Detail;
